export default {
  name: "yugan k",
  feedback: `Salem cake craft studio Best class covered all recipies mentioned with detailed practical knowledge in techniques and ingredients ,ramya mam cleared all doubts .
  we baked japanese bun ,milk bread ,korean cheese garlic bun, coconut bun,crosent,dominos garlic bread,spicy bun ,focaccia ,cheese blast pizza ,hiraliya twisted roll,choclate bun all were tasty 😋 and soo soft .`
};
